import * as React from "react";
const SvgFiRrStarChristmas = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-christmas_svg__a)">
      <path
        fill="#062147"
        d="m22.986 10.487-4.566-1.88 3.414-5.12c.572-.866-.456-1.894-1.322-1.322l-5.125 3.401-1.874-4.554a1.63 1.63 0 0 0-1.514-1.013c-.665 0-1.26.397-1.514 1.013L8.611 5.565l-5.124-3.4c-.866-.572-1.894.455-1.322 1.322l3.414 5.12-4.565 1.88A1.63 1.63 0 0 0-.001 12c0 .666.398 1.26 1.014 1.513l4.559 1.877-3.407 5.11c-.572.866.456 1.894 1.322 1.322l5.121-3.398 1.878 4.564A1.63 1.63 0 0 0 12 24.001c.665 0 1.26-.397 1.514-1.013l1.878-4.563 5.121 3.398c.866.572 1.894-.455 1.322-1.322l-3.407-5.11 4.558-1.877a1.63 1.63 0 0 0 1.015-1.513 1.63 1.63 0 0 0-1.014-1.513zm-7.857 4.099a1 1 0 0 0-.544.544L12 21.41l-2.585-6.28a1 1 0 0 0-.544-.544l-6.279-2.585 6.279-2.585c.246-.102.442-.297.544-.544L12 2.592l2.585 6.28c.102.247.298.442.544.544l6.279 2.585z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-christmas_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarChristmas;
